import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import AnonShell from '@/components/layout/AnonShell';
import { PageContentLoader } from '@/components/layout/PageContentLoader';
import { useAuth } from '@/hooks/use-auth';

const AppLayout = lazy(() => import('@/components/layout/AppLayout'));
const MainLayout = lazy(() => import('@/components/layout/MainLayout'));

export default function PublicAppLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div aria-hidden="true" className="min-h-screen" />;
  }

  if (user) {
    return (
      <Suspense fallback={<PageContentLoader />}>
        <AppLayout>
          <MainLayout>
            <Suspense fallback={<PageContentLoader />}>
              <Outlet />
            </Suspense>
          </MainLayout>
        </AppLayout>
      </Suspense>
    );
  }

  return (
    <AnonShell>
      <Suspense fallback={<PageContentLoader />}>
        <Outlet />
      </Suspense>
    </AnonShell>
  );
}
